import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter, Selection } from 'devextreme-react/data-grid';
import Loader from '../../Utils/Loader/NewLoader2025'
import type { ColumnCellTemplateData } from 'devextreme/ui/data_grid';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import DateBox from 'devextreme-react/date-box';

interface AnalysisData {
    battery: number
    coverageClass: number
    dateCreated: Date
    details: string
    energyLevel: number
    eventCode: number
    id: number
    loggerSerial: number
    porbor: number
    powerSavingConnsPerc: number | null
    recordCode: number
    remainingBattPerc: number | null
    remainingBattYears: number | null
    rssi: number
    siteName: string
    userFatal: number
    watchdogResets: number
    cellId: number | null
    actType: number | null
    band: number | null
    iccId: number | null
}

const DeviceAnalysis: React.FC = ({ serial }: { serial: number }) => {




    const [start, setStart] = useState<Date | null>(moment().subtract(7, 'days').toDate())
    const [end, setEnd] = useState<Date | null>(moment().toDate())
    const [gridData, setGridData] = useState<AnalysisData[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)
        CallGetAPI(CreateUrl(`/api/aquaguard/LoggerEvents?serial=${serial}&startDate=${moment(start).format("yyyy-MM-DD HH:mm:ss")}&endDate=${moment(end).format("yyyy-MM-DD HH:mm:ss") }`), {})
            .then(data => {
                if (data && data.length > 0) {
                    const filteredData = data.filter((d: AnalysisData) => d.eventCode === 42)
                    filteredData.forEach((d: AnalysisData) => {
                        if (d.battery) {
                            d.battery = d.battery / 1000
                        }

                        ///cellid
                        const cellIdIdx = d.details.indexOf('CellId')
                        const tacIdx = d.details.indexOf('TAC')

                        d.cellId = parseInt(d.details.slice(cellIdIdx + 8, tacIdx - 1))


                        ///actType
                        const actIdx = d.details.indexOf('AcT')
                        console.log(actIdx, cellIdIdx)
                        d.actType = parseInt(d.details.slice(actIdx + 10, cellIdIdx - 1))


                        ///band
                        const bandIdx = d.details.indexOf('Band')
                        const iccidIdx = d.details.indexOf('ICCID')
                        d.band = parseInt(d.details.slice(bandIdx + 6, iccidIdx - 5))


                        ///iccid 
                        const tempIdx = d.details.indexOf('Temp')
                        d.iccId = parseInt(d.details.slice(iccidIdx + 7, tempIdx - 1))
                    })
                    setGridData(filteredData)
                    setLoading(false)
                } else {
                    setGridData([])
                    setLoading(false)
                }
            })
            .catch(err => {
                console.error(err)
                setLoading(false)
            })
    }, [start, end])


    const renderDate = (data: ColumnCellTemplateData):React.ReactNode => {
        return moment(data.data.dateCreated).format('DD MMM YYYY HH:mm:ss')
    }

    const startDateChanged = (e):void => {
        setStart(moment(e.value).set({ hours: 0, minutes: 0, second: 0 }).toDate())
    }

    const endDateChanged = (e) => {
        setEnd(moment(e.value).set({hours: 23, minutes: 59, second: 59}).toDate())
    }

    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading && <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                    Start date:&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={start} onValueChanged={startDateChanged} />
                </GridItem>
                <GridItem xs={6} sm={6} md={4} >
                    End date:&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={end} onValueChanged={endDateChanged} />
                </GridItem>
                
                <div style={{marginTop: 30} }>
                <GridItem xs={12} sm={12} md={12}>
                    <DataGrid
                        dataSource={gridData}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                    >
                        <StateStoring enabled={true} type="localStorage" storageKey="deviceAnalysisGrid" />
                        {/*<Export enabled={true} />*/}
                        <FilterRow visible={true} />
                        <Column dataField='dateCreated' cellRender={(data): React.ReactNode => renderDate(data)} dataType='datetime' />
                        <Column dataField='battery' caption='Battery (V)' dataType='number' />
                        <Column dataField='rssi' dataType='number' />
                        <Column dataField="coverageClass" dataType='number' />
                        <Column dataField="energyLevel" dataType='number' />
                        <Column dataField='porbor' dataType='number' />
                        <Column dataField='userFatal' dataType='number' />
                        <Column dataField='watchdogResets' dataType='number' />
                        <Column dataField='cellId' dataType='number' />
                        <Column dataField='actType' dataType='number' />
                        <Column dataField='band' dataType='number' />
                        <Column dataField='iccId' dataType='number' />
                    </DataGrid>
                    </GridItem>
                </div>
            </GridContainer>}
        </div>
    )
}
export default DeviceAnalysis